import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[hoverHighlight]',
})
export class HoverHighlightDirective implements OnDestroy {
  private static instances: HoverHighlightDirective[] = [];
  private static initialized = false;
  private readonly HIGHLIGHT_CLASS = 'hover-highlight';

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {
    HoverHighlightDirective.instances.push(this);
    this.ensureListener();
  }

  ngOnDestroy(): void {
    this.unregister();
  }

  private ensureListener(): void {
    if (HoverHighlightDirective.initialized) {
      return;
    }
    this.renderer.listen('document', 'pointermove', this.onPointerMove.bind(this));
    HoverHighlightDirective.initialized = true;
  }

  private unregister(): void {
    HoverHighlightDirective.instances = HoverHighlightDirective.instances.filter(
      (instance: HoverHighlightDirective) => instance !== this,
    );
  }

  private onPointerMove(event: PointerEvent): void {
    const top = this.findTopInstance(event.clientX, event.clientY);
    this.updateHighlights(top);
  }

  private findTopInstance(x: number, y: number): HoverHighlightDirective | null {
    const elements = document.elementsFromPoint(x, y) as HTMLElement[];
    for (const element of elements) {
      const inst = HoverHighlightDirective.instances.find(
        (instance: HoverHighlightDirective) => instance.el.nativeElement === element,
      );
      if (inst) {
        return inst;
      }
    }
    return null;
  }

  private updateHighlights(active: HoverHighlightDirective | null): void {
    for (const instance of HoverHighlightDirective.instances) {
      const method = instance === active ? 'addClass' : 'removeClass';
      instance.renderer[method](instance.el.nativeElement, instance.HIGHLIGHT_CLASS);
    }
  }
}
